module.exports = __webpack_public_path__ + "static/media/pg23.5f5b1199.jpg";